export default {
  currentPeriod: 'Período reciente',
  displacedPeriod: 'Período anterior',
};
